import React from "react";
import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";

export default function BusinessBeneficios({
    title = "",
    text = "",
    buttonText = "",
    buttonLink = "",
    buttonActionText = "",
    items = [],
}) {
    const { openModal } = useModal();

    return (
        <div className="w-full bg-[#040116] py-20 relative overflow-hidden">
            {/* Background com grafismos */}
            <div className="absolute inset-0 opacity-10 flex justify-end">
                <img
                    src="/assets/grafismos2.png"
                    alt="Grafismos"
                    className="h-full object-contain object-right-top"
                />
            </div>
            
            <div className="max-w-[1200px] mx-auto px-4 flex flex-col lg:flex-row gap-16 relative z-10">
                {/* Coluna da esquerda - Título, descrição e botão */}
                <div className="lg:w-1/2 flex flex-col justify-center px-24">
                    <h2 className="text-white text-6xl font-inter-bold mb-8">
                        {title}
                    </h2>
                    <div className="text-white mb-10">
                        <p className="text-xl mb-4 leading-8">
                            <span className="">
                                {text}
                            </span>
                        </p>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-4 mt-8">
                        <div className="bg-[#2A0D5D] bg-opacity-70 rounded-3xl px-8 py-3 inline-flex items-center justify-center">
                            <span className="text-white text-xl font-inter-light">
                                {buttonText}
                            </span>
                            <button
                                onClick={() => openModal(<FormularioRD />)}
                                className="cursor-pointer bg-gradient-to-r from-[#4B3BDB] to-[#A002CB] rounded-full px-6 py-3 inline-flex items-center justify-center w-[150px] h-[38px] hover:scale-105 transition-all duration-300"
                            >
                                <span className="text-white text-sm font-poppins-light mr-2">
                                    {buttonActionText}
                                </span>
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M5 12H19M19 12L12 5M19 12L12 19"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Coluna da direita - Lista de benefícios */}
                <div className="lg:w-1/2 grid grid-cols-1 gap-8 px-6">
                    {items.map((item, index) => (
                        <div key={index} className="flex items-start gap-8">
                            <div className="relative">
                                {/* Purple blur effect behind the circle */}
                                <div className="absolute w-12 h-12 rounded-full bg-[#A002CB] blur-xl opacity-70" style={{ zIndex: 1 }}></div>
                                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center flex-shrink-0 relative" style={{ zIndex: 2 }}>
                                    <img
                                        src={item.icon}
                                        alt={item.title}
                                        className="w-8 h-8 text-[#A002CB]"
                                    />
                                </div>
                            </div>
                            <div>
                                <h3 className="text-[#A800E4] text-[20px] font-inter-bold mb-1">
                                    {item.title}
                                </h3>
                                <p className="text-white font-inter-regular">
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
